// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2J0qI","choiceBoxes":"toolbarselects_choiceBoxes__WhzPA","simpleField":"toolbarselects_simpleField__1y24E"};